import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AppUserAvailabilityPublic from "components/AppUserComponents/AppUserDetails/AppUserAvailibility/AppUserAvailabilityPublic/AppUserAvailabilityPublic";

const AppUserAvailabilityPublicPage = () => {
  useEffect(() => {
    document.title = "App user";
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="appuser" />

      <AppUserAvailabilityPublic />
    </main>
  );
};

export default AppUserAvailabilityPublicPage;
